exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-customize-enter-active {\n  transition: opacity 0.9s;\n}\n.fade-customize-leave-active  {\n  transition: opacity 0s;\n}\n.fade-customize-enter, .fade-customize-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n", ""]);

// exports
